module.exports = __webpack_public_path__ + "img/apple-fill.d620ec25.png";